import Reporter from '../Reporter';
import cookie from '../cookie';
import { getVuid } from './index';
import { version } from '../package.json';
var reporter = new Reporter(7481, '692842614');
reporter.init({
  f_version: window.__LOGIN_VERSION__ || '',
  f_lib_version: version,
  f_guid: cookie.get('guid') || cookie.get('video_guid'),
  f_video_platform: cookie.get('video_platform')
});
window.addEventListener('load', function () {
  // 待页面加载完再进行上报
  reporter.ready();
});
export function report(params) {
  params.f_vuserid = getVuid();
  reporter.report(params);
} // ---------------- Login 库事件

export var EVENT_INIT_START = 'INIT_START'; // login库 - 初始化开始

export var EVENT_INIT_SYNC = 'INIT_SYNC'; // login库 - 初始化同步登录态

export var EVENT_INIT_GETCOOKIE = 'INIT_GETCOOKIE'; // login库 - 初始化获取 cookie

export var EVENT_INIT_REFRESH = 'INIT_REFRESH'; // login库 - 初始化续期登录态

export var EVENT_INIT_READY = 'INIT_READY'; // login库 - 初始化完成

export var EVENT_INIT_LOGIN = 'INIT_LOGIN'; // login库 - 登录

export var EVENT_INIT_LOGOUT = 'INIT_LOGOUT'; // login库 - 退出登录

export var EVENT_INIT_REQUEST = 'INIT_REQUEST'; // login库 - 请求接口

export var EVENT_INIT_COOKIE_ONLOAD = 'INIT_COOKIE_ONLOAD'; // login库 - cookie加载完成

export var EVENT_INIT_COOKIE_LOADED = 'INIT_COOKIE_LOADED'; // login库 - cookie同步

export var EVENT_INIT_COOKIE_TIMEOUT = 'INIT_COOKIE_TIMEOUT'; // login库 - cookie超时
// ---------------- 登录页事件

export var EVENT_LOGIN_INIT = 'LOGIN_INIT'; // 登录页 - 初始化

export var EVENT_LOGIN_START = 'LOGIN_START'; // 登录页 - 开始登录

export var EVENT_LOGIN_AUTH = 'LOGIN_AUTH'; // 登录页 - 登录回调授权

export var EVENT_LOGIN_FAIL = 'LOGIN_FAIL'; // 登录页 - 登录失败

export var EVENT_LOGIN_TIMEOUT = 'LOGIN_TIMEOUT'; // 登录页 - 登录超时